import React from 'react';
import { IconCheckmark16, IconCalendar16 } from '@dhis2/ui';
import './checkInComponents.css';

const ManagerReviewPanel = ({ checkInData, onSaveReview, onScheduleMeeting, onUpdateCheckIn, isSaving }) => {
  // Use root-level fields instead of overall object
  const setField = (field, value) =>
    onUpdateCheckIn(prev => ({ ...prev, [field]: value }));

  return (
    <div>
      <h3 className="cc-summary-title">Manager Review</h3>

      <div className="cc-field">
        <label className="cc-label">Review Comments</label>
        <textarea
          className="cc-textarea"
          placeholder="Share your overall feedback for this check-in..."
          value={checkInData.managerReviewComments || ''}
          onChange={(e) => onUpdateCheckIn(prev => ({ ...prev, managerReviewComments: e.target.value }))}
        />
      </div>

      <div className="cc-field" style={{ marginBottom: 0 }}>
        <label className="cc-label">Next Steps / Action Items</label>
        <textarea
          className="cc-textarea"
          placeholder="Define agreed action items..."
          value={checkInData.managerReviewNextSteps || ''}
          onChange={(e) => onUpdateCheckIn(prev => ({ ...prev, managerReviewNextSteps: e.target.value }))}
        />
      </div>

      <div className="cc-stack">
        <button type="button" className="cif-btn cif-btn--indigo cif-btn--block" onClick={onScheduleMeeting}>
          <IconCalendar16 /> Schedule Meeting
        </button>
        <button type="button" className="cif-btn cif-btn--success cif-btn--block" disabled={isSaving} onClick={onSaveReview}>
          <IconCheckmark16 /> {isSaving ? 'Saving...' : 'Complete Review'}
        </button>
      </div>
    </div>
  );
};

export default ManagerReviewPanel;